module.exports = __webpack_public_path__ + "static/yellow_divider_top-45074035e1460358d79356b847b20f01.png";